import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

/** Provides a console warning if a translation is missing */
export class CustomMissingTranslationHandler implements MissingTranslationHandler {
  public handle(params: MissingTranslationHandlerParams) {
    console.warn('MISSING TRANSLATION: ', params.key);
  }
}
